<template>
  <div class="uses--content">
    <div
      class="
        uses--wrapper
        py-24
        2xl:w-2/5
        xl:w-3/5
        md:w-4/5
        w-5/6
        mr-auto
        ml-auto
      "
    >
      <div class="top--head text-center">
        <generic-header :content="getHeaderContent" />
      </div>
      <div class="uses--content--wrapper md:mt-40 mt-28">
        <uses-each
          v-for="(value, id) in getThings"
          :thing="value"
          :key="id"
          class="border-b last:border-0"
        />
      </div>
      <p class="md:mt-16 mt-8 text-gray-600">
        Content is updated as of January 9, 2023.
      </p>
    </div>
  </div>
</template>

<script>
import GenericHeader from "./GenericHeader.vue";
import UsesEach from "./UsesEach.vue";
import thingList from "@/static/uses.js";

export default {
  name: "UsesContent",
  components: { GenericHeader, UsesEach },
  computed: {
    getThings() {
      return thingList;
    },
    getHeaderContent() {
      return {
        heading: "Software & Hardware I use on a daily basis",
        text: "I absolutely enjoy DIY OS's like Arch Linux but also love the efficiency of new M1 macs. Also, Mechanical Keyboards!",
      };
    },
  },
};
</script>
